<template>
    <div v-if="showTime">
        <div class="m-model-bg" ></div>
        <div class="rgt-m-model" >
            <div class="model-title-box">
                <div style="font-size:14px;padding-left:5px">{{title}}</div>
                <i class="icon iconguanbi" @click="closeModel" style="font-size:17px;margin-right:15px"></i>
            </div>
            <div>
              <van-search v-model="keyword" @search="currentPage=1;getData()" placeholder="请输入搜索关键词" />
              <div style="height: calc(100vh - 154px);margin-top:10px;padding:0px 10px" >
                <van-list
                  v-model="loading"
                  :finished="allData"
                  :immediate-check="false"
                  finished-text="没有更多了"
                  @load="onLoad"
                >
                  <van-radio-group v-model="radio">
                    <van-cell-group>
                      <van-cell title-style="font-size:14px" v-for="(item,index) in datas" :title="(index*1+1)+'. '+item.name" clickable @click="radio = item.id;selectItem=item;selsectData()">
                       
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </van-list>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['title','datas','valueKey','label','value','item','orgType'],
    data() {
        return {
            datas:[],
            showTime:false,
            tabType: '0',
            startTime:'',
            endTime:'',
            radio:'',
            loading:false,
            allData:false,
            keyword:"",
            currentPage:1,
            selectItem:{}
        };
    },

    mounted() {
        
    },
    methods: {
        open(){
          this.keyword=''
          this.currentPage=1
          this.getData()
          this.showTime=true;
        },
        getData() {
          this.loading=true
          this.$request.get("index/getOrganizations",{orgType:this.orgType,pageNum:this.currentPage,pageSize:20,keyword:this.keyword}).then(data=>{
            if(data.status==200){

            
              this.loading=false
              if(this.currentPage>=data.content.totalPages){
                this.allData=true
              }
              if(this.currentPage==1){
                this.datas=data.content.content
              }else{
                this.datas=this.datas.concat(data.content.content)
              }
            }else{
              this.loading=false
              this.allData=true
            }
          }).catch(()=>{
            this.loading=false
          })
        },
        onLoad(){
          this.currentPage++
          this.getData()
        },
        selsectData(){
            this.$emit("update:value",this.radio)
            this.$emit("update:item",this.selectItem)
            this.$emit("change",this.selectItem)
            
            this.showTime=false
        },
        closeModel(){
            this.showTime=false
        },
    },
};
</script>

<style scoped>
    
.m-model-bg {
  position: fixed;
  width: calc(100%);
  height: 100vh;
  right: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  /* background-color: #fff; */
  padding: 0px;
  box-sizing: border-box;
  z-index: 101;
}

.rgt-m-model {
  position: fixed;
  width: calc(100% - 60px);
  right: 0px;
  top: 0px;
  height: 100vh;
  padding: 0px 5px;
  /* background-color: #F6F6F6; */
  background-color: #fff;
  box-sizing: border-box;
  z-index: 102;
}

.m-model .model-tl {
  display: flex;
  align-items: center;
}

.m-model .model-tl .tl-text {
  flex: 1;
  font-size: 15px;
}

.m-model .model-tl .tl-text span {
  padding-bottom: 2px;
  color: #FFF;
  border-bottom: 3px solid #ccc
}

.m-model .model-tl .tl-icon {
  flex: 1;
  text-align: right;
}

.m-model .model-tl .tl-icon span {
  font-size: 15px;
  color: #FFF
}

.m-model .good-btn {
  margin-top: 7px;
}

.m-model .good-btn button {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #FFF;
  width: 100%;
  background-color: #486ad8
}

.model-title-box {
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  align-items: center;
  border-bottom: 1px solid #ddd;
  color: #888
}

.search {
  margin: 10px 10px;
  border-radius: 5px;
  /* padding:0px 36px 20px 36px; */
  background: #FFF;
}

.search-lst {
  display: flex;
  justify-content: space-between
}

.search-lst-tag {
  width: 48%;
  /* padding:20px 0; */
  height: 32px;
  line-height: 32px;
  padding-top: 7px;
  display: flex;
  border-bottom: 1px solid #eee
}

.lst-tag-vle {
  width: 100%;
  text-align: center;
  /* font-weight:700; */
  color: #666;
  font-size: 13px;
}

.lst-tag-vle .placeholder {
  color:#adadad;
  font-size:12px;
  text-align: left;
}

.search-btn-group {
  width: 100%;
  display: flex;
  border-radius: 4px;
  background: #777;
  display: flex;
  align-items: center;
  justify-content: space-between
}

.search-btn {
  color: #fff;
  display: flex;
  width: 49%;
  justify-content: center;
  font-size: 14px;
}

.search .search-menu {
  display: flex;
  flex-wrap: wrap;
}

.search .search-menu .select span {

  border-bottom: 2px solid #52B381;
}

.search .search-menu .menu-time {
  width: 34%;
  text-align: center;
  font-size: 14px;
  position: relative;
}

.search .search-menu .small {
  width: 16% !important;
}

.search .search-menu .middle {
  width: 20% !important;
}

.search .search-menu .menu-time::after {
  content: '';
  /*CSS伪类用法*/
  position: absolute;
  /*定位背景横线的位置*/
  top: 30%;
  right: 0px;
  background: #CCC;
  /*宽和高做出来的背景横线*/
  width: 1px;
  height: 14px;
}

.search .search-menu .menu-time:nth-child(5)::after {
  width: 0px;
}

.search .search-menu .menu-time span {
  display: inline-block;
  padding: 7px 0px;
}

.search-filter {
  display: flex;
  margin-bottom: 20px;
}

.search .search-val {
  display: flex;
  padding-top: 20px;
  align-items: center;
  padding: 0px 20px;
  box-sizing: border-box;
  width: 100%
}

.search .search-val .val-line {
  font-size: 12px;
  width: 20px;
  text-align: center;
}

.search .search-val .val-item {
  width: calc(50% - 20px);
  text-align: center;
  font-size: 14px;
}

.search .search-val .filter-item {
  /* background-color:#52B381; */
  border-bottom: 1px solid #52B381;
}

.search .val-more {
  width: 150px;
  text-align: center;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search .search-val .val-item span {
  padding-bottom: 10px;
  /* border-bottom: 1px solid #ddd */
}

.search .search-no {
  display: flex;
}

.btn-group {
  display: flex;
  width: 400px;
  border-radius: 8px;
  width: 80%;
  margin-left:10px;
  color: #fff;
  height: 44px;
  line-height: 44px;
  align-items: center;
  background:#4C37B6
}
</style>


// WEBPACK FOOTER //
// src/components/selectMerchant/index.vue